import { guideCards } from "../../../mocks/portalData";

export default function GuideCards() {
  return (
    <section className="mx-auto mt-6 w-full max-w-[1320px] px-4 md:mt-8 md:px-6">
      <div className="flex items-center justify-between border-b border-background-200 pb-3">
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-primary-500"></span>
          <h3 className="font-heading text-lg font-black text-foreground-950">头版导读</h3>
        </div>
        <a href="#flow" className="flex items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 hover:text-primary-700">
          更多热议
          <i className="ri-arrow-right-s-line text-base"></i>
        </a>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {guideCards.map((card, idx) => (
          <a
            href="#flow"
            key={idx}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-background-300"
          >
            <div className="relative h-40 w-full overflow-hidden md:h-44">
              <img
                src={card.image}
                alt={card.title}
                title={`${card.label} 52黑料`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-2.5 top-2.5 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-bold text-background-50">
                {card.label}
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-between gap-2 p-3.5">
              <h4 className="text-sm font-bold leading-relaxed text-foreground-950 transition-colors group-hover:text-primary-600">
                {card.title}
              </h4>
              <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-fire-line text-primary-500"></i>
                <span className="font-bold text-foreground-600">{card.heat} 热度</span>
                <span className="ml-auto flex items-center gap-1 opacity-0 transition-opacity group-hover:opacity-100">
                  去围观
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}